import React from 'react';
import { DeleteModal, getTranslatedText } from '@nile/components';
import { Button } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { injectIntl } from 'react-intl';

function DeleteActionCell(props) {
  const { cell, intl } = props;
  const { actions, meta: customMeta } = cell.column;
  const meta = cell?.row?.original;

  return (
    <span className="action-button">
      {(meta.custom || customMeta?.custom) && (
        <DeleteModal
          modalActivator={
            <Button icon={<SVGIcon name="Delete" />} plainSecondary></Button>
          }
          description={getTranslatedText(
            intl,
            customMeta?.description || 'snmp.custom.delete.monitor.content',
            {
              reportType: customMeta?.fileType
            }
          )}
          handleDeleteConfirmation={() => {
            actions.delete(meta);
          }}
          variant="confirmation"
          title={getTranslatedText(
            intl,
            customMeta?.title || 'snmp.custom.delete.monitor',
            {
              reportType: customMeta?.fileType
            }
          )}
          sectioned={false}
        />
      )}
    </span>
  );
}

export default injectIntl(DeleteActionCell);
